import { render, staticRenderFns } from "./fragment-form.vue?vue&type=template&id=72d05760&scoped=true&"
import script from "./fragment-form.vue?vue&type=script&lang=js&"
export * from "./fragment-form.vue?vue&type=script&lang=js&"
import style0 from "./fragment-form.vue?vue&type=style&index=0&id=72d05760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d05760",
  null
  
)

export default component.exports